import React from 'react'
import { RADOM_COLORS } from './Constants'

export const TRAVEL_RULES_COMPLIANCE_BANNER: React.ReactElement =
  <div style={{
    flex: 1,
    fontSize: 10,
    marginTop: 15,
    color: RADOM_COLORS.GRAY_DARKER,
    overflowWrap: 'break-word'
  }}>
    <span>
      We ask for your billing details to meet standard compliance requirements.&nbsp;
      All personal information is kept secure and is only used where needed for license purposes.
    </span>
  </div>

